import { useCallback, useRef, useState } from "react";

export function useElementHeight<T extends HTMLElement>(): [(node: T | null) => void, number] {
  const [height, setHeight] = useState(0);
  const observerRef = useRef<ResizeObserver>(null);

  const callbackRef = useCallback((node: T | null) => {
    observerRef.current?.disconnect();
    observerRef.current = null;

    if (node) {
      setHeight(node.offsetHeight);
      observerRef.current = new ResizeObserver(() => setHeight(node.offsetHeight));
      observerRef.current.observe(node);
    }
  }, []);

  return [callbackRef, height];
}
